<script lang="ts">
	//Hooks
	import { createEventDispatcher, getContext } from 'svelte';
	import { tweened } from 'svelte/motion';
	//Types
	import type { MapContext } from '../../../types/requests/services/weather';

	const { getMap }: MapContext = getContext('map'),
		map = getMap(),
		dispatcher = createEventDispatcher();

	export let id = null,
		lat = 0,
		lng = 0,
		data = null,
		selected = false,
		draggable = false;

	const fadeAnime = tweened(0, {
		duration: 350,
	});

	const initMapMarker = (element) => {
		//@ts-ignore
		const marker = new mapboxgl.Marker({ element, draggable, anchor: 'bottom' })
			.setLngLat([lng, lat])
			.addTo(map);
		const onClickHandler = (e) => {
			e.stopPropagation();
			const lngLat = marker.getLngLat();
			dispatcher('click', {
				id,
				lat: lngLat.lat,
				lng: lngLat.lng,
				data,
			});
		};
		const onDragEnd = (e) => {
			const lngLat = marker.getLngLat();
			dispatcher('dragEnd', {
				lat: lngLat.lat,
				lng: lngLat.lng,
			});
		};
		if (draggable) {
			marker.on('dragend', onDragEnd);
		} else {
			element.addEventListener('click', onClickHandler);
		}
		fadeAnime.set(1);
		return {
			destroy() {
				fadeAnime.set(0);
				if (draggable) {
					marker.off('dragend', onDragEnd);
				} else {
					element.removeEventListener('click', onClickHandler);
				}
				marker.remove();
			},
		};
	};
</script>

<div class="marker" class:selected style="opacity: {$fadeAnime};" use:initMapMarker>
	<slot />
</div>

<style>
	.marker {
		z-index: 1;
		filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.25));
	}
	.marker.selected {
		pointer-events: none;
	}
</style>
